import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchLoadBookingOverview = createAsyncThunk(
  "loadBooking/fetchLoadBookingOverview",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getLoadBookingOverview();
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch load booking overview");
    }
  }
);

export const createLoadBooking = createAsyncThunk(
  "loadBooking/createLoadBooking",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiService.createLoadBooking(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to create load booking");
    }
  }
);

export const fetchLoadBookingsPaginated = createAsyncThunk(
  "loadBooking/fetchLoadBookingsPaginated",
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiService.getLoadBookingsPaginated(params);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch load bookings");
    }
  }
);

export const fetchLoadBookingDetail = createAsyncThunk(
  "loadBooking/fetchLoadBookingDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiService.getLoadBookingDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue(error || "Failed to fetch load booking detail");
    }
  }
);

const initialState = {
  loadBookingOverviewData: null,
  loadBookingOverviewLoading: false,
  loadBookingOverviewError: null,
  loadBookingPaginatedData: null,
  loadBookingPaginatedLoading: false,
  loadBookingPaginatedError: null,
  loadBookingDetailData: null,
  loadBookingDetailLoading: false,
  loadBookingDetailError: null,
  createLoadBookingData: null,
  createLoadBookingLoading: false,
  createLoadBookingError: null,
};

const loadBookingSlice = createSlice({
  name: "loadBooking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoadBookingOverview.pending, (state) => {
        state.loadBookingOverviewLoading = true;
        state.loadBookingOverviewError = null;
      })
      .addCase(fetchLoadBookingOverview.fulfilled, (state, action) => {
        state.loadBookingOverviewLoading = false;
        state.loadBookingOverviewData = action.payload?.data || null;
        state.loadBookingOverviewError = null;
      })
      .addCase(fetchLoadBookingOverview.rejected, (state, action) => {
        state.loadBookingOverviewLoading = false;
        state.loadBookingOverviewError = action.payload;
      })
      .addCase(fetchLoadBookingsPaginated.pending, (state) => {
        state.loadBookingPaginatedLoading = true;
        state.loadBookingPaginatedError = null;
      })
      .addCase(fetchLoadBookingsPaginated.fulfilled, (state, action) => {
        state.loadBookingPaginatedLoading = false;
        state.loadBookingPaginatedData = action.payload?.data || null;
        state.loadBookingPaginatedError = null;
      })
      .addCase(fetchLoadBookingsPaginated.rejected, (state, action) => {
        state.loadBookingPaginatedLoading = false;
        state.loadBookingPaginatedError = action.payload;
      })
      .addCase(fetchLoadBookingDetail.pending, (state) => {
        state.loadBookingDetailLoading = true;
        state.loadBookingDetailError = null;
      })
      .addCase(fetchLoadBookingDetail.fulfilled, (state, action) => {
        state.loadBookingDetailLoading = false;
        state.loadBookingDetailData = action.payload?.data || null;
        state.loadBookingDetailError = null;
      })
      .addCase(fetchLoadBookingDetail.rejected, (state, action) => {
        state.loadBookingDetailLoading = false;
        state.loadBookingDetailError = action.payload;
      })
      .addCase(createLoadBooking.pending, (state) => {
        state.createLoadBookingLoading = true;
        state.createLoadBookingError = null;
      })
      .addCase(createLoadBooking.fulfilled, (state, action) => {
        state.createLoadBookingLoading = false;
        state.createLoadBookingData = action.payload?.data || null;
        state.createLoadBookingError = null;
      })
      .addCase(createLoadBooking.rejected, (state, action) => {
        state.createLoadBookingLoading = false;
        state.createLoadBookingError = action.payload;
      });
  },
});

export default loadBookingSlice.reducer;
